export class SetupDrugLabelModel {
    rx_sequence: number
    refill_count: number
    refill_expire: string
    next_rx_date: string
    code_no: number
    pet_no: number
    rx_clinic: number

    constructor(
        rx_sequence: number,
        refill_count: number,
        refill_expire: string,
        next_rx_date: string,
        code_no: number,
        pet_no: number,
        rx_clinic: number
    ) {
        this.rx_sequence = rx_sequence
        this.refill_count = refill_count
        this.refill_expire = refill_expire
        this.next_rx_date = next_rx_date
        this.code_no = code_no
        this.pet_no = pet_no
        this.rx_clinic = rx_clinic
    }
}